import React from "react";
import "./About.css";

function About() {
  const timeline = [
    {
      period: "2025.07 ~ 현재",
      title: "교외 보안 스터디 '보안공방' 창설/운영",
      desc: "스터디 기획, 운영, 실습 중심 보안 학습 진행",
    },
    {
      period: "2025.04 ~ 2026.02",
      title: "전공 동아리 '모디' 활동",
      desc: "보안/개발 프로젝트 협업 및 기술 공유",
    },
    {
      period: "2025.04 ~ 2025.10",
      title: "대구대학교 정보보호영재교육 이수",
      desc: "보안 기초부터 실습 중심 커리큘럼 학습",
    },
    {
      period: "2024.04 ~ 2025.02",
      title: "교내 보안 동아리 'AND' 활동",
      desc: "운영체제, 네트워크, 웹 보안 기본기 강화",
    },
    {
      period: "2024.03 ~ 2027.02",
      title: "대구소프트웨어마이스터고 재학",
      desc: "소프트웨어개발과에서 보안/백엔드 역량 성장",
    },
  ];

  return (
    <main className="about">
      <section className="about-section summary">
        <div className="container">
          <h1>About Me</h1>
          <p>
            서비스에 대한 깊은 이해를 바탕으로 보안을 적용하는 사이버보안 중심 인재입니다. 단순한 기능 구현을 넘어 서비스 구조를 분석하고, 취약점 분석, 인증/권한 설계, 트래픽 대응, 운영 안정성까지 고려한 안전한 서비스를 구축하는 것을 지향합니다.
          </p>
        </div>
      </section>

      <section className="about-section">
        <div className="container two-col">
          <article className="about-card">
            <h2>강점</h2>
            <ul>
              <li>보안과 개발을 함께 이해하는 문제 해결 방식</li>
              <li>3회의 팀장 경험으로 협업/커뮤니케이션 역량 보유</li>
              <li>실무형 프로젝트에서 API, DB, 인프라를 통합적으로 수행</li>
              <li>새로운 기술을 빠르게 습득하고 적용</li>
            </ul>
          </article>

          <article className="about-card">
            <h2>자격 및 수상</h2>
            <ul>
              <li>TOPCIT 2수준 (2024)</li>
              <li>해킹보안전문가 3급 (2026)</li>
              <li>사이버테러 대응 시나리오 공모전 장려상</li>
            </ul>
          </article>
        </div>
      </section>

      <section className="about-section timeline-section">
        <div className="container">
          <h2>활동 이력</h2>
          <div className="timeline">
            {timeline.map((item) => (
              <div className="timeline-item" key={`${item.period}-${item.title}`}>
                <div className="period">{item.period}</div>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
